import AuthRoute from './auth.route'

function AuthLayout() {
  return <AuthRoute />
}

export default AuthLayout
